angular.module('homebot.directives')

.directive('noLoansSection', ['Dictionary', 'DataService', 'UtilService', function(Dictionary, DataService, utils){
  return {
    restrict: 'A',
    controllerAs: 'noLoansCtrl',
    bindToController: {
      loans: '=',
      homeId: '@',
      addLoanAction: '&',
      noLoanAction: '&',
    },
    scope: {},
    templateUrl: '/homes/templates/section-no-loans.html',

    controller: function(){
      var dictionary = new Dictionary();
      var ctrl = this;

      ctrl.lookup = function(prop,args,home){
        var home = {loans: ctrl.loans};
        return dictionary[prop](home,args);
      };

      ctrl.update = function(){
        ctrl.helocCount = ctrl.lookup('currentHelocs').length;
      };

      ctrl.saveHomePaidInFull = function(){
        DataService.saveAnswer('isHomePaidInFull', true, ctrl.homeId)
          .then(() => {
            ctrl.noLoanAction();
          })
          .catch((err) => {
            utils.trackException('Save Answer', err);
          });
      };
    },

    link: function($scope, el, attrs, ctrl){
      $scope.$watchCollection('noLoansCtrl.loans', function(newVal){
        ctrl.update();
      });
    }
  }
}]);
